export interface PluginModelPickerSnapshot {
  readonly ready: boolean;
  readonly enabled: boolean;
  readonly accountScopeKey: string;
  readonly contextGeneration: number;
}

type PluginModelPickerListener = () => void;

const DISABLED_SNAPSHOT: PluginModelPickerSnapshot = Object.freeze({
  ready: false,
  enabled: false,
  accountScopeKey: "",
  contextGeneration: 0,
});

let snapshot = DISABLED_SNAPSHOT;
const listeners = new Set<PluginModelPickerListener>();

function isSameSnapshot(
  left: PluginModelPickerSnapshot,
  right: PluginModelPickerSnapshot
): boolean {
  return (
    left.ready === right.ready &&
    left.enabled === right.enabled &&
    left.accountScopeKey === right.accountScopeKey &&
    left.contextGeneration === right.contextGeneration
  );
}

export function publishPluginModelPickerSnapshot(next: PluginModelPickerSnapshot): void {
  if (isSameSnapshot(snapshot, next)) return;
  snapshot = Object.freeze({ ...next });
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.warn("[PluginModelPicker] Listener threw", error);
    }
  });
}

export function getPluginModelPickerSnapshot(): PluginModelPickerSnapshot {
  return snapshot;
}

export function getPluginModelPickerServerSnapshot(): PluginModelPickerSnapshot {
  return DISABLED_SNAPSHOT;
}

export function isPluginModelPickerEnabled(): boolean {
  return snapshot.ready && snapshot.enabled && snapshot.accountScopeKey.trim().length > 0;
}

export function subscribePluginModelPicker(listener: PluginModelPickerListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Test seam. Production state arrives only through the ConfigCat service. */
export function resetPluginModelPickerForTests(): void {
  snapshot = DISABLED_SNAPSHOT;
  listeners.forEach((listener) => listener());
}
